import React from 'react';
import { useTranslation } from 'react-i18next';

import Tabs from 'components/Tabs';

import SectionWrapper from 'pages/Layout/SectionWrapper';

import AdminProfile from './AdminProfile';
import ChangePassword from '../ChangePassword';
import TwoFABadget from './2FA/2FABadget/2FABadget';

const AdminSettings = () => {
  const { t } = useTranslation(['settings']);
  return (
    <SectionWrapper>
      <h1>{t('settings')}</h1>
      <Tabs
        orientation="vertical"
        tabsTitle={[
          { id: 1, label: t('account') },
          { id: 2, label: t('password') },
          { id: 3, label: t('auth') }
        ]}
        tabsContent={[
          { id: 1, children: <AdminProfile /> },
          { id: 2, children: <ChangePassword /> },
          { id: 3, children: <TwoFABadget /> }
        ]}
      />
    </SectionWrapper>
  );
};

export default AdminSettings;
